import Search from './search';
Search.install = function (app) {
    app.component(Search.name, Search);
    app.component(Search.Key.name, Search.Key);
    return app;
};
export default Search;
